import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import { familyMembersCollection } from 'app/src/msw/membership/initialSeed/familyMembers'
import { membershipCollection } from 'app/src/msw/membership/initialSeed/membership'
import { welfareCampaignCollection } from 'app/src/msw/membership/initialSeed/welfareCampign'
import type { membershipApi } from 'app/src/services/welfareportal'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

export const getMembershipById = http.get<
  { membershipId: string },
  DefaultBodyType,
  membershipApi.MembershipExtended | membershipApi.ErrorEntityNotFound
>(apiBaseUrl + '/memberships/:membershipId', async ({ request, params }) => {
  const url = new URL(request.url)
  const includeFamilyMembers: boolean = JSON.parse(url.searchParams.get('includeFamilyMembers') ?? 'false')
  const includePrizeGroups: boolean = JSON.parse(url.searchParams.get('includePrizeGroups') ?? 'false')
  const membership: membershipApi.Membership | undefined = membershipCollection.findFirst((q) =>
    q.where({ membershipId: params.membershipId }),
  )
  if (!membership) {
    const responseError: membershipApi.ErrorEntityNotFound = {
      status: 404,
      title: 'Membership non trovata',
      type: 'urn:notfound',
      rc: 404,
    }
    return HttpResponse.json(responseError, { status: 404 })
  }
  // Aggiungi family members se richiesto
  if (includeFamilyMembers) {
    membership.userFamilyMembers = familyMembersCollection.findMany()
    membership.userFamilyMembersPrivacyTemplateURL =
      'https://companywelfaresvil.poste.it/static/documents/privacy/Modulo_consenso_al_trattamento_dei_dati_particolari_Informativa_privacy_welfare_2024_97103880585.pdf'
  }

  // Aggiungi prize groups se richiesto
  if (includePrizeGroups) {
    const companyPrize: membershipApi.PrizeGroup[] = await (await fetch('./data/membership/companyPrize.json')).json()
    membership.companyPrize = companyPrize
  }

  const welfareCampaign: membershipApi.CompanyWelfareCampaign | undefined = welfareCampaignCollection.findFirst((q) =>
    q.where({ campaignId: params.membershipId }),
  )

  if (!welfareCampaign) {
    const responseError: membershipApi.ErrorEntityNotFound = {
      status: 404,
      title: 'Welfare Campaign non trovata',
      type: 'urn:notfound',
      rc: 404,
    }
    return HttpResponse.json(responseError, { status: 404 })
  }

  const baseMembership: membershipApi.MembershipExtended = {
    membershipInfo: {
      ...membership,
      userEmail: membership.userEmail ?? 'test@email.com',
    },
    welfareCampaign,
    userWelfareMode: 'fruition',
  }

  return HttpResponse.json(baseMembership)
})
